<form [formGroup]="schedulerForm" nz-form nzLayout="vertical">
  <div class="scheduler-modal-content">
    <p class="section-title">Scheduler Details</p>

    <div nz-row class="scheduler-details">
      <div nz-col nzSpan="8" class="mt6">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="schedulerName" class="nfl-form-label">Name</nz-form-label>
          <nz-form-control [nzErrorTip]="nameErrorTemplate">
            <input
              nz-input
              maxlength="45"
              id="schedulerName"
              nzSize="default"
              nzPlaceHolder="Enter Schedule Name"
              formControlName="schedulerName"
            />
          </nz-form-control>
          <ng-template #nameErrorTemplate let-control>
            <div *ngIf="control?.errors?.['required']">Name is required.</div>
            <div *ngIf="control?.errors?.['maxlength']">
              Name cannot exceed
              {{ control?.errors?.['maxlength'].requiredLength }} characters.
            </div>
            <div *ngIf="control?.errors?.['pattern']">
              Name should not contain any special characters and should have at least one alphabet.
            </div>
          </ng-template>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired nzFor="selectedQuery" class="nfl-form-label">Query (From History)</nz-form-label>
          <nz-form-control>
            <nz-select
              id="selectedQuery"
              nzPlaceHolder="Select query"
              nzSize="default"
              formControlName="selectedQuery"
              nzShowSearch
              nzAllowClear
              nzOptionFilterProp="nzLabel"
              (ngModelChange)="getSelectedQueryData($event)"
            >
              <nz-option *ngFor="let data of selectQueryOptions" [nzLabel]="data.name" [nzValue]="data.value">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired nzFor="selectedTimezone" class="nfl-form-label">Time zone</nz-form-label>
          <nz-form-control>
            <nz-select
              id="selectedTimezone"
              nzPlaceHolder="Select time zone"
              nzSize="default"
              formControlName="selectedTimezone"
            >
              <nz-option
                *ngFor="let data of selectTimezoneOptions"
                [nzLabel]="data.name"
                [nzValue]="data.value"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="16">
        <div class="query-panel">
          <label class="nfl-form-label" class="nfl-form-label" for="query-panel">Query</label>
          <div class="query-preview">{{ queryRaw }}</div>
          <span nz-icon nzType="info-circle" nzTheme="outline" class="info-icon"></span>
          <span>{{ queryDescription }}</span>
        </div>
      </div>
    </div>
    <p class="section-title">Scheduler Occurrence</p>
    <nz-tabset
      nzType="card"
      [nzDestroyInactiveTabPane]="true"
      (nzSelectedIndexChange)="onTabChange($event)"
      [nzTabBarExtraContent]="rightText"
    >
      <nz-tab nzTitle="One-Time">
        <div
          *ngIf="schedulerForm.value.scheduleType === 'ONE_TIME'"
          formGroupName="schedule"
          class="one-time-content-container"
        >
          <span>Will run once on</span>

          <nz-date-picker
            class="space-input-inline"
            [nzDisabledDate]="disabledPastDate"
            formControlName="date"
            nzPlaceHolder="mm/dd/yyyy"
          >
          </nz-date-picker>

          <span>at</span>

          <nz-time-picker class="space-input-inline" formControlName="time" nzPlaceHolder="hh:mm:ss"> </nz-time-picker>
        </div>
      </nz-tab>

      <nz-tab nzTitle="Recurring">
        <div
          *ngIf="schedulerForm.value.scheduleType === 'RECURRING'"
          formGroupName="schedule"
          class="recurring-container"
        >
          <nz-radio-group formControlName="recurrenceFrequency">
            <label nz-radio nzValue="DAILY">Daily</label>
            <label nz-radio nzValue="WEEKLY">Weekly</label>
            <label nz-radio nzValue="MONTHLY">Monthly</label>
          </nz-radio-group>

          <div formGroupName="recurrence" class="repeat-frequency">
            <span>Repeat every</span>
            <nz-input-number
              class="space-input-inline input-number-width"
              formControlName="interval"
              [nzMin]="1"
              [nzMax]="99"
              [nzStep]="1"
              [nzPrecision]="0"
            >
            </nz-input-number>

            <span *ngIf="schedulerForm.value.schedule?.recurrenceFrequency === 'WEEKLY'"> week(s) </span>

            <span *ngIf="schedulerForm.value.schedule?.recurrenceFrequency === 'DAILY'"> day(s) </span>

            <span *ngIf="schedulerForm.value.schedule?.recurrenceFrequency === 'MONTHLY'"> month(s) </span>

            <nz-time-picker class="space-input-inline" formControlName="time" nzPlaceHolder="hh:mm:ss">
            </nz-time-picker>

            <span>starting</span>

            <nz-date-picker
              class="space-input-inline"
              [nzDisabledDate]="disabledPastDate"
              formControlName="startDate"
              nzPlaceHolder="mm/dd/yyyy"
            >
            </nz-date-picker>

            <div
              *ngIf="
                schedulerForm.value.schedule?.recurrenceFrequency === 'WEEKLY' &&
                schedulerForm.get('schedule.recurrence.daysOfWeek')
              "
              class="weekly-repeat-on-section"
            >
              <span>Repeat on (please select dates which are at least 2 days apart)</span>

              <nz-button-group class="weekly-btn-group">
                <button
                  *ngFor="let item of dayOfWeekOption"
                  nz-button
                  nzShape="circle"
                  class="weekly-btn"
                  [nzType]="isSelected(item.value) ? 'primary' : 'default'"
                  (click)="selectDayOfWeek(item.value)"
                  [disabled]="isDisabled(item.value)"
                >
                  {{ item.name[0] }}
                </button>
              </nz-button-group>
            </div>

            <div
              *ngIf="
                schedulerForm.value.schedule?.recurrenceFrequency === 'MONTHLY' &&
                schedulerForm.get('schedule.recurrence.repeatType')
              "
            >
              <div *ngIf="schedulerForm.get('schedule.recurrence.repeatType')">
                <p>Repeat:</p>
                <nz-radio-group formControlName="repeatType" class="radio-group-panel">
                  <div nz-row class="mb6">
                    <div nz-col nzSpan="8">
                      <label nz-radio nzValue="on-day">On day</label>
                    </div>
                    <div nz-col nzSpan="16">
                      <nz-input-number
                        class="space-input-inline input-number-width"
                        formControlName="dateOfMonth"
                        [nzMin]="1"
                        [nzMax]="31"
                        [nzStep]="1"
                        [nzPrecision]="0"
                      ></nz-input-number>
                    </div>
                  </div>

                  <div nz-row class="mb6">
                    <div nz-col nzSpan="8">
                      <label nz-radio nzValue="on-the">On the</label>
                    </div>

                    <div nz-col nzSpan="8">
                      <nz-select formControlName="weekOfMonth" class="w100">
                        <nz-option *ngFor="let data of weekOfMonthOption" [nzLabel]="data.name" [nzValue]="data.value">
                        </nz-option> </nz-select
                      >&nbsp;
                    </div>

                    <div nz-col nzSpan="8">
                      <nz-select formControlName="dayOfWeek" class="w100">
                        <nz-option *ngFor="let data of dayOfWeekOption" [nzLabel]="data.name" [nzValue]="data.value">
                        </nz-option>
                      </nz-select>
                    </div>
                  </div>
                </nz-radio-group>
              </div>
            </div>
            <div *ngIf="schedulerForm.get('schedule.recurrence.endType')">
              <p>Ends:</p>

              <nz-radio-group formControlName="endType" class="radio-group-panel">
                <label nz-radio nzValue="NEVER">Never</label>

                <div nz-row class="mb6">
                  <div nz-col nzSpan="8">
                    <label nz-radio nzValue="ON_DATE">On</label>
                  </div>
                  <div nz-col nzSpan="16">
                    <nz-date-picker
                      class="w120"
                      [nzDisabledDate]="disabledPastDateForEnds"
                      formControlName="endDate"
                      [nzDisabled]="schedulerForm.value.schedule?.recurrence?.endType !== 'ON_DATE'"
                    >
                    </nz-date-picker>
                  </div>
                </div>

                <div nz-row class="mb6">
                  <div nz-col nzSpan="8">
                    <label nz-radio nzValue="AFTER_OCCURRENCES">After</label>
                  </div>
                  <div nz-col nzSpan="16">
                    <nz-input-number
                      class="w120"
                      formControlName="occurrences"
                      [nzDisabled]="schedulerForm.value.schedule?.recurrence?.endType !== 'AFTER_OCCURRENCES'"
                      nzMin="1"
                    >
                    </nz-input-number>
                  </div>
                </div>
              </nz-radio-group>
            </div>
          </div>

          <!-- Recurrence Summary -->
          <p nz-typography *ngIf="summary" class="recurrence-summary">
            {{ summary }}
          </p>
        </div>
      </nz-tab>
    </nz-tabset>

    <ng-template #rightText>
      <span nz-icon nzType="info-circle" nzTheme="outline"></span>
      <span nz-typography>
        New Data becomes available every 48 hours, scheduling more often won't produce new results
      </span>
    </ng-template>
  </div>
</form>

<div class="footer">
  <button nz-button class="cancel-btn" nzSize="large" (click)="close()">Cancel</button>

  <button
    nz-button
    class="create-btn"
    nzSize="large"
    [nzLoading]="isLoading"
    (click)="createSchedule()"
    [disabled]="schedulerForm.invalid"
  >
    Create
  </button>
</div>
